"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_1 = __importStar(require("../../i18n"));
const Badge = styled_components_1.default.img `
  width: 32px;
  position: absolute;
  top: 0;
  right: 0;
  clip-path: polygon(0 0, 100% 0, 100% 100%); /* triangle */
  opacity: 0.5;

  &:hover {
    cursor: pointer;
    clip-path: none;
    opacity: 1;
  }
`;
const LanguagesSwitcher = () => {
    const [lng, setLng] = (0, react_1.useState)(i18n_1.default.language);
    (0, react_1.useEffect)(() => {
        i18n_1.default.changeLanguage(lng);
    });
    const lngIndex = i18n_1.lngList.findIndex((l) => l.tag === lng);
    const lngProps = i18n_1.lngList[lngIndex];
    const nextLng = i18n_1.lngList[(lngIndex + 1) % i18n_1.lngList.length];
    return (0, jsx_runtime_1.jsx)(Badge, { src: lngProps.icon, alt: lngProps.lng, onClick: () => setLng(nextLng.tag) });
};
exports.default = LanguagesSwitcher;
